import React, { useEffect, useState, useCallback } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import styles from './styles';
import { selectModelsName, selectModelDescription } from '../../../redux/selectors/modelsSelector';
import RBIAutocomplete from '../../RBIAutocomplete/RBIAutocomplete';
import RBIAutocompleteSearch from '../../RBIAutocompleteSearch/RBIAutocompleteSearch';
import SpecificDataRow from './SpecificDataRow';
import { getEntities as getCategories } from '../../../redux/actions/categoriesActions';
import { getEntities as getSuppliers } from '../../../redux/actions/suppliersActions';
import { getEntities as getModels } from '../../../redux/actions/modelsActions';
import { getEntities as getCalibrationProfiles } from '../../../redux/actions/calibrationProfilesActions';
import { getEntities as getRestaurantZones } from '../../../redux/actions/restautantZones';
import { UpdateEquipmentPieces } from '../../../redux/actions/equipment-specificActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
// import { getEquipments } from '../../../redux/actions/equipment-specificActions';
import {
  clearEntitiesPieces as clearEquipments,
  getEntitiesPieces as getEquipments,
} from '../../../redux/actions/equipmentsActions';
import { SpecificDataInterface } from './SpecificDataInterface';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from "../../../utils/utils";

const EquipmentCreateEditSpecificData = ({
  open,
  handleClose,
  restaurantId,
  handleRefreshOnCreate,
}) => {
  const classes = styles();
  const dispatch: any = useDispatch();
  const { selectedLanguage } = useSelector(
    (state: RootStateOrAny) => state.AppReducer.selectedLanguage,
  );
  const models = useSelector((state: RootStateOrAny) =>
    selectModelsName(state),
  );

  const description = useSelector((state: RootStateOrAny) =>
  selectModelDescription(state),
  );

  const categories = useSelector(
    (state: RootStateOrAny) => state.CategoriesReducer.entities,
  );
  const suppliers = useSelector(
    (state: RootStateOrAny) => state.SuppliersReducer.entities,
  );
  const zones = useSelector(
    (state: RootStateOrAny) => state.RestaurantZonesReducer.entities,
  );
  const calibrationProfiles = useSelector(
    (state: RootStateOrAny) => state.CalibrationProfilesReducer.entities,
  );
  const equipments = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.entitiesPieces,
  );
  const [addMoreDisabledButton, setaddMoreDisabledButton] = useState(true);
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  // const [pieces, setPieces] = useState<SpecificDataInterface[]>([]);
  const [pieces, setPieces] = useState(equipments);

  const { t } = useTranslation();

  const SpecificDataStrings = {
    description: t('equipment.description'),
    edit_success: t('equipment.editSuccess'),
    edit_error: t('equipment.editError'),
    edit_title: t('equipment.editTitle'),
    equipment: t('equipment.equipment'),
    no_available: t('equipment.noAvailable'),
    select_options: t('equipment.selectOptions'),
    create_edit_success: t('equipment.createEditSuccess'),
    create_edit_error: t('equipment.createEditError'),
    create_title: t('equipment.createTitle'),
    category: t('equipment.category'),
    supplier: t('equipment.supplier'),
    model: t('equipment.model'),
    search: t('app.common.search'),
    add_more: t('equipment.addMore'),
    cancel: t('app.common.cancel'),
    save: t('app.common.save'),
  };

  useEffect(() => {
    if (open && selectedBrand) {
      dispatch(getCategories({ brand: selectedBrand, restaurantId }));
      dispatch(getModels({ brand: selectedBrand, restaurantId, limit: 500 }));
      dispatch(
        getSuppliers({
          brand: selectedBrand,
          restaurantId: restaurantId,
          limit: 100,
        }),
      );
      dispatch(getRestaurantZones(selectedBrand));
      if (selectedBrand === 'TH') {
        dispatch(getCalibrationProfiles(restaurantId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, selectedBrand]);

  const [searchObject, setSearchObject] = useState<any>({
    category: '',
    supplier: '',
    model: '',
    description: '',
  });
  const [searchObjectPrev, setSearchObjectPrev] = useState<any>({
    category: '',
    supplier: '',
    model: '',
    description: '',
  });

  const [descriptionInput,setDescriptionValue]:any =useState({})
  const [modelInput,setModelValue]:any =useState({})

  const modelValueTransferToDescription = (value) =>{
    const modelValue = JSON.parse(JSON.stringify(value));
    modelValue.name = modelValue.description;
    setDescriptionValue(modelValue);
    setModelValue(value);
    setSearchObjectPrev({
      ...searchObject,
      description: modelValue,
      model: value
    });
    // if (!value) {
    setSearchObject({
      ...searchObject,
      description: modelValue,
      model: value
    });
  }

  const descriptionValueTransferToModel = (value) => {
    const descriptionValue = JSON.parse(JSON.stringify(value));
    descriptionValue.name = descriptionValue.description;
    setModelValue(descriptionValue);
    setDescriptionValue(value);
    setSearchObjectPrev({
      ...searchObject,
      description: value,
      model: descriptionValue
    });
    // if (!value) {
    setSearchObject({
      ...searchObject,
      description: value,
      model: descriptionValue
    });
  }

  const [modelInputV, setModelInput] = useState<string>('');
  const [timer, setTimer] = useState<any>(null);

  const callBackFunctionModels = useCallback(
    value => {
      clearTimeout(timer);
      if (modelInputV !== value && (value.length > 0 || value === '')) {
        setModelInput(value);
        setTimer(
          setTimeout(
            () =>
              dispatch(
                getModels({ brand: selectedBrand, name: value || null }),
              ),
            1000,
          ),
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timer, setModelInput, setTimer],
  );

  const handleChangeInputComplete = (name: string, value: any) => {
    if(name === "model" && value){
      callBackFunctionModels(value);
    }
  };
  
  const handleChangeAutocomplete = (name: string, value: any) => {
    if(name === "model" && value){
      modelValueTransferToDescription(value);
    }
    else if(name === "description" && value){
      descriptionValueTransferToModel(value)
    }
    else {
  setSearchObjectPrev({
    ...searchObject,
    [name]: value ? value : '',
  });
  // if (!value) {
  setSearchObject({
    ...searchObject,
    [name]: value ? value : '',
  });
  // }
}
    
  };
  const [equipmentId, setEquipmentId] = useState(0);

  const handleSearchButton = async () => {
    if (
      searchObject['category'] !== '' &&
      searchObject['supplier'] !== '' &&
      searchObject['model'] !== '' && 
      searchObject['description'] !== ''
    ) {
      try{
        let data = await getEquipments({
          brand: selectedBrand,
          category: searchObjectPrev.category.id,
          supplier: searchObjectPrev.supplier.id,
          model: searchObjectPrev.model.name,
          description: searchObjectPrev.description.name,
          restaurantId: restaurantId,
          pieces: true,
        })(dispatch);
        if (
          data.equipments.length > 0 &&
          data.equipments[0].equipment_restaurant.length > 0 &&
          data.equipments[0].equipment_restaurant[0].id > 0
        ) {
          setaddMoreDisabledButton(false);
          setEquipmentId(data.equipments[0].equipment_restaurant[0].id);
          setPieces(data.pieces);
        } else {
          dispatch(snackbarShowMessage(SpecificDataStrings.no_available));
        }  
      }catch(err){
        setaddMoreDisabledButton(true);
        dispatch(snackbarShowMessage(SpecificDataStrings.no_available));
      }
    } else {
      dispatch(snackbarShowMessage(SpecificDataStrings.select_options));
    }
  };

  const addMoreRows = () => {
    setPieces([
      ...pieces,
      {
        serial_number: '',
        alternate_name: '',
        restaurant_zone_id: 0,
        equipment_restaurant_id: equipmentId,
        calibration_profile: null,
        equipment_purchase_date: null
      },
    ]);
  };

  const updateEquipmentPiece = (name, index, value) => {
    let copyOfPieces = [...pieces];
    copyOfPieces[index][name] = value;
    setPieces(copyOfPieces);
  };

  const handleChangeTextFields = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const [name, index] = event.target.name.split('-');
    updateEquipmentPiece(name, index, event.target.value);
  };
  const handleChangeSelect = (
    event: React.ChangeEvent<{ value: unknown; name: string }>,
  ) => {
    const { value } = event.target;
    const [name, index] = event.target.name.split('-');
    updateEquipmentPiece(name, index, value === '' ? null : value);
  };

  const handleChangeDateFields = (
    fieldName, value
  ) => {
    const [name, index] = fieldName.split('-');
    updateEquipmentPiece(name, index, value);
  };
    

  const [deletedIDs, setDeletedIDs] = useState<number[]>([]);
  const removeRow = index => () => {
    if (pieces.length === 1) return;
    let copyOfPieces = [...pieces];
    if (copyOfPieces[index].id) {
      setDeletedIDs([...deletedIDs, copyOfPieces[index]?.id]);
    }
    copyOfPieces.splice(index, 1);
    setPieces([...copyOfPieces]);
  };

  const clearData = () => {
    setDeletedIDs([]);
    setPieces([]);
    handleClose();
    setaddMoreDisabledButton(true);
    setSearchObjectPrev({
      category: '',
      supplier: '',
      model: '',
      description: '',
    });
    setSearchObject({
      category: '',
      supplier: '',
      model: '',
      description: '',
    });
    dispatch(clearEquipments());
    setDescriptionValue("");
    setModelValue("");
  };

  const saveEquipmentPieces = async () => {
    let newPieces: any[] = [];
    let editPieces: SpecificDataInterface[] = [];
    const piecesToUpdate = {};
    pieces.forEach(piece => {
      let pieceCopy = { ...piece };
      if (!piece.calibration_profile) {
        delete pieceCopy['calibration_profile'];
      }
      if (piece.id) {
        editPieces.push(pieceCopy);
      } else {
        newPieces.push(pieceCopy);
      }
    });
    if (editPieces.length) piecesToUpdate['editPieces'] = editPieces;
    if (newPieces.length) piecesToUpdate['newPieces'] = newPieces;
    if (deletedIDs.length) piecesToUpdate['deletedPieces'] = deletedIDs;
    clearData();
    const response: any = await dispatch(UpdateEquipmentPieces(piecesToUpdate));
    if (response?.status === 200) {
      dispatch(snackbarShowMessage(SpecificDataStrings.create_edit_success));
    } else {
      dispatch(snackbarShowMessage(SpecificDataStrings.create_edit_error));
    }
    handleRefreshOnCreate();
  };

  const isValid = () => {
    return (
      pieces?.length === 0 ||
      !pieces?.every(
        p =>
          p.alternate_name &&
          p.restaurant_zone_id &&          
          +p.restaurant_zone_id !== 0 &&
          p.alternate_name.length <= 100   
      )
    );
  };
  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={clearData}
      aria-labelledby="max-width-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title">
          <div className={classes.flexSpaceBetween}>
            <Typography variant="h6">
              {SpecificDataStrings.create_title}
            </Typography>
            <IconButton
              style={{ position: 'relative', left: '40px' }}
              onClick={clearData}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <div className={classes.flexSpaceBetween}>
          <RBIAutocomplete
            id={'category'}
            value={searchObjectPrev['category']}
            label={SpecificDataStrings.category}
            onChangeInput={handleChangeAutocomplete}
            options={categories.map(option => ({
              ...option, 
              name: t(`equipment.categories.${textToSnakeCase(option.name)}`, option.name)
            }))}
            width={200}
            searchIcon
            getOptionSelected={(option, value) => option.name === value}
          />

          <RBIAutocomplete
            id={'supplier'}
            value={searchObjectPrev['supplier']}
            label={SpecificDataStrings.supplier}
            onChangeInput={handleChangeAutocomplete}
            options={suppliers}
            width={200}
            searchIcon
            getOptionSelected={(option, value) => option.name === value}
          />

          <RBIAutocompleteSearch
            id={'model'}
            value={modelInput}
            label={SpecificDataStrings.model}
            onChangeInput={handleChangeInputComplete}
            onChange={handleChangeAutocomplete}
            options={models}
            width={200}
            getOptionSelected={(option, value) => option.name === value.name}
          />
            <RBIAutocompleteSearch
            id={'description'}
            value={descriptionInput}
            label={SpecificDataStrings.description}
            onChange={handleChangeAutocomplete}
            options={description}
            width={200}
            getOptionSelected={(option, value) => option.name === value}
          />
        </div>
        <div className={classes.toTheRight}>
          <Button
            onClick={handleSearchButton}
            color="primary"
            variant="contained"
          >
            {SpecificDataStrings.search}
          </Button>
        </div>
        <div>
          <AppBar position="static">
            <Toolbar variant="dense" className={classes.equipmentAppbar}>
              <Typography>{SpecificDataStrings.equipment}</Typography>
              <Button
                onClick={addMoreRows}
                color="default"
                data-testid='add_more'
                disabled={addMoreDisabledButton}
                endIcon={<AddIcon />}
              >
                {SpecificDataStrings.add_more}
              </Button>
            </Toolbar>
          </AppBar>
          <Paper>
            <div>
              {pieces?.length ? (
                pieces.map((piece, index) => (
                  <SpecificDataRow
                    key={`${piece?.id ? piece.id : 'default'}_${index}`}
                    selectedLanguage={selectedLanguage ||
                      localStorage.getItem('selectedLanguage') || 'eng'}
                    brand={selectedBrand}
                    index={index}
                    piece={piece}
                    handleChangeSelect={handleChangeSelect}
                    handleChangeTextField={handleChangeTextFields}
                    handleChangeDateField={handleChangeDateFields}
                    removeRow={removeRow}
                    calibrationProfiles={calibrationProfiles}
                    zones={zones}
                    removeOption={pieces.length>1}
                  />
                ))
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <Typography>{SpecificDataStrings.no_available}</Typography>
                </div>
              )}
            </div>
          </Paper>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={clearData} color="primary" variant="outlined">
          {SpecificDataStrings.cancel}
        </Button>
        <Button
          onClick={saveEquipmentPieces}
          color="secondary"
          variant="outlined"
          disabled={isValid()}
        >
          {SpecificDataStrings.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EquipmentCreateEditSpecificData;
